import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import merge from 'lodash.merge';
import RaisedButton from 'material-ui/RaisedButton';
import * as styles from './Button.scss';
import { connect } from 'react-redux';
var GrayButton = (_dec = connect(function (state, ownProps) {
  return {
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(GrayButton, _Component);

  var _super = _createSuper(GrayButton);

  function GrayButton() {
    _classCallCheck(this, GrayButton);

    return _super.apply(this, arguments);
  }

  _createClass(GrayButton, [{
    key: "render",
    value: function render() {
      console.warn("<GrayButton /> is a connected component. Either ensure this component has access to the Redux Provider or, if you do not need this to be Redux connected, consider using Material UI's built in <RaisedButton />.");
      var style = merge({}, {
        borderRadius: 4,
        color: this.props.theme.colors.gray2,
        minWidth: 120
      }, this.props.style);
      return /*#__PURE__*/React.createElement(RaisedButton, {
        backgroundColor: 'transparent',
        className: styles.button,
        fullWidth: true,
        label: this.props.label,
        onSubmit: this.props.onSubmit,
        onClick: this.props.onClick,
        style: style,
        type: this.props.type
      });
    }
  }]);

  return GrayButton;
}(Component), _defineProperty(_class2, "propTypes", {
  label: PropTypes.string,
  style: PropTypes.object,
  onSubmit: PropTypes.func,
  onClick: PropTypes.func
}), _defineProperty(_class2, "defaultProps", {
  label: 'Submit',
  style: {},
  type: 'button',
  onSubmit: null,
  onClick: undefined
}), _temp)) || _class);
export { GrayButton as default };